export const POPUP_TYPES = {
  CONFIRMATION_EXPIRED: 'confirmation-expired',
  RESERVATION_EXPIRED: 'reservation-expired',
  PAYMENT_DECLINED: 'payment-declined',
  RESERVATION_ERROR: 'reservation-error',
  PAYMENT_ERROR: 'payment-error',
  PAYMENT_IN_PROGRESS: 'payment-in-progress',
  BOOKING_AMENDMENT: 'booking-amendment',
  BOOKING_TRIP_DETAILS: 'booking-trip-details',
  CHECKOUT_TRIP_DETAILS: 'checkout-trip-details',
  EXPRESS_EXPIRED: 'express-expired',
} as const

export const POPUP_OUTCOMES = {
  CLOSED: 'closed',
  RETRY: 'retry',
  REDIRECT: 'redirect',
  PAGE_RELOAD: 'page-reload',
} as const

export type PopupTypeValue = (typeof POPUP_TYPES)[keyof typeof POPUP_TYPES]
export type PopupOutcomeValue = (typeof POPUP_OUTCOMES)[keyof typeof POPUP_OUTCOMES]
